import React, { useState } from 'react'
import Message from '../message/message'
import styles from './styles.scss'

/**
  * @param currentTaskId     当前所在任务的id
  * @param homeworkBeginTask 作业开始任务的索引
  * @param lessonProgress    当前课程task列表
  * @param onSelect          外部传入方法 切换当前所在任务
*/

const TaskProgressBar = ({
  currentTaskId,
  homeworkBeginTask,
  lessonProgress,
  onSelect
}) => {
  const [tasks, setTasks] = useState(lessonProgress || [])
  const [homeworkBegin, setHomeworkBegin] = useState(homeworkBeginTask >= 0 ? homeworkBeginTask : -1)
  const [taskTitle, setTaskTitle] = useState('')

  const handleClick = (item, index) => {
    if (item.id === currentTaskId) return
    if (item.status === 1) {
      Message.show(window.L('teach.menu.itemNotAvailable'))
      return
    }
    onSelect && onSelect(item, index)
  }

  const handleHover = item => {
    setTaskTitle(item.content)
  }

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.tasks}>
          {
            tasks instanceof Array && tasks.map((item, index) => {
              const colors = [
                { status: 1, value: '#575e75bf', image: require('./images/star_locked@2x.png') },
                { status: 2, value: '#ffffff', image: require('./images/star_current@2x.png') },
                { status: 3, value: '#575e75', image: require('./images/star_unlocked@2x.png') }
              ]
              let star = item.status > 1 ? colors[2] : colors[0]

              if (item.id === currentTaskId) {
                star = colors[1]
              }

              if (index === homeworkBegin) {
                return <div key={index} style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                  <div className={styles.task_split}></div>
                  <a
                    className={styles.task_item}
                    title={taskTitle}
                    style={{ backgroundImage: 'url(' + star.image + ')' }}
                    onClick={() => handleClick(item, index)}
                    onMouseEnter={() => handleHover(item)}
                  >
                    <span style={{ color: star.value }}>{index + 1}</span>
                  </a>
                </div>
              }
              return <a
                key={index}
                className={styles.task_item}
                title={taskTitle}
                style={{ backgroundImage: 'url(' + star.image + ')' }}
                onClick={() => handleClick(item, index)}
                onMouseEnter={() => handleHover(item)}
              >
                <span style={{ color: star.value }}>{index + 1}</span>
              </a>
            })
          }
        </div>
      </div>
    </div>
  )
}

export default TaskProgressBar
